
import { Component, Mixins } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import { Dish, Restaurant } from '@/api/model';
import DishForm from '@/components/menu-engineering/DishForm.vue';
import MessageToastMixin from '@/mixins/MessageToastMixin';

@Component({
  components: { LayoutDefault, DishForm },
})
export default class MenuEngineeringEditDish extends Mixins(MessageToastMixin) {
  // Dish model for the form
  dish: Dish = {};

  saving = false;

  get state() {
    return this.$store.state.menuEngineering;
  }

  // List of user dishes
  get dishes(): Dish[] {
    return this.state.dishes;
  }

  // User restaurants
  get restaurants(): Restaurant[] {
    return this.$store.state.restaurant.restaurants;
  }

  created() {
    const editDish = this.dishes.find(
      (dish) => dish.id === this.$route.params.dishId,
    );
    this.dish = { ...editDish };
  }

  async save() {
    this.saving = true;
    try {
      await this.$store.dispatch('menuEngineering/saveDish', this.dish);
      this.saving = false;
      await this.$router.push('/menu-engineering/add-dish');
    } catch (e) {
      this.saving = false;
      this.showError(this.$t('general.messages.error'));
    }
  }
}
